/* eslint-disable @typescript-eslint/no-explicit-any */

import { trackMediaStreamChunkTrackStateError } from '@/lib/analytics/scribe/general';
import { stopMediaRecorder } from '@/lib/utils';
import { store } from '@/store';
import { logger } from '@/utils/logger/logger';
import { type IMediaRecorder } from 'extendable-media-recorder';
import posthog from 'posthog-js';
import { isSafari } from 'react-device-detect';
export const DEFAULT_CHUNK_DURATION = 45;
export const GEMINI_TRANSCRIBER = 'Gemini';

type OnDataAvailableHandler = (data: Blob) => void;
type OnStopHandler = (blob: Blob) => void;

class OfflineRecorder {
  private static instance: OfflineRecorder;
  public mediaRecorder: IMediaRecorder | null;
  private chunks: Blob[];
  private stream: MediaStream | null;
  //   private audioContext: AudioContext;
  //   private mediaStreamDestination: MediaStreamAudioDestinationNode;
  public ondataavailable: OnDataAvailableHandler | null;
  public onstop: OnStopHandler | null;

  private constructor() {
    this.mediaRecorder = null;
    this.chunks = [];
    this.stream = null;
    // this.audioContext = new (window.AudioContext ||
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    //   (window as any).webkitAudioContext)();
    // this.mediaStreamDestination = this.audioContext.createMediaStreamDestination();
    this.ondataavailable = null;
    this.onstop = null;

    // void this.init();
  }

  public static getInstance(): OfflineRecorder | OfflineRecorderV2 {
    if (
      posthog.isFeatureEnabled('release-chunk-recording') ||
      posthog.getFeatureFlag('config-default-transcriber') === GEMINI_TRANSCRIBER
    ) {
      return OfflineRecorderV2.getInstance();
    }
    if (!OfflineRecorder.instance) {
      OfflineRecorder.instance = new OfflineRecorder();
    }
    return OfflineRecorder.instance;
  }

  private async init() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      void this.handleStream(stream);
    } catch (error) {
      logger.error('Error accessing audio devices:', error);
    }
  }

  private handleStream(stream: MediaStream) {
    this.stream = stream;
    if (this.mediaRecorder) {
      stopMediaRecorder(this.mediaRecorder);
      this.mediaRecorder = null;
    }

    // const source = this.audioContext.createMediaStreamSource(stream);
    // source.connect(this.mediaStreamDestination);

    //   const mimeType = this.getSupportedMimeType();

    const track = stream.getAudioTracks().at(0); // Get the first audio track
    if (track) {
      if (track.muted || !track.enabled || track.readyState === 'ended') {
        trackMediaStreamChunkTrackStateError({
          error: `${track.id} track has error, track.enabled: ${track.enabled}, track.muted: ${track.muted}, track.readyState: ${track.readyState}`,
        });
      }
    } else {
      trackMediaStreamChunkTrackStateError({
        error: `No track found`,
      });
    }

    this.mediaRecorder = new MediaRecorder(stream, {
      // mimeType,
    });

    // this.mediaRecorder.addEventListener() = (e: BlobEvent) => {
    //   debugger;
    //   if (this.ondataavailable) {
    //     this.ondataavailable(e.data);
    //   }
    //   this.chunks.push(e.data);
    // };

    // Handling mediaRecorder events
    this.mediaRecorder?.addEventListener('dataavailable', (e) => {
      // logger.debug('audioRecorder data available', e.data.size);

      //   debugger
      if (this.ondataavailable) {
        this.ondataavailable(e.data);
      }
      this.chunks.push(e.data);
    });

    this.mediaRecorder.addEventListener('stop', () => {
      const mimeType = this.mediaRecorder?.mimeType;
      const blob = new Blob(this.chunks, { type: mimeType });
      this.chunks = [];
      if (this.onstop) {
        this.onstop(blob);
      }
      // Handle the blob further if needed (e.g., save, play, upload)
    });
  }

  public async start() {
    if (!this.stream) {
      await this.init();
    }
    // debugger;
    if (this.mediaRecorder && this.mediaRecorder.state === 'inactive') {
      this.mediaRecorder.start(1000);
    }
  }

  public stop() {
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop();
    }

    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  }

  public async changeInputDevice(deviceId: string) {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: false,

        audio: isSafari
          ? {
              deviceId: deviceId,
            }
          : {
              autoGainControl: false,
              echoCancellation: false,
              noiseSuppression: false,

              deviceId: deviceId,
            },
      });
      this.handleStream(stream);
    } catch (error) {
      logger.error('Error changing audio input device:', error);
    }
  }

  public setOnDataAvailableHandler(handler: OnDataAvailableHandler) {
    this.ondataavailable = handler;
  }

  public setOnStopHandler(handler: OnStopHandler) {
    this.onstop = handler;
  }
}

class OfflineRecorderV2 {
  private static instance: OfflineRecorderV2;
  public mediaRecorder: IMediaRecorder | null;
  private chunks: Blob[];
  // private stream: MediaStream | null;
  //   private audioContext: AudioContext;
  //   private mediaStreamDestination: MediaStreamAudioDestinationNode;
  public ondataavailable: OnDataAvailableHandler | null;
  public onstop: OnStopHandler | null;

  private constructor() {
    this.mediaRecorder = null;
    this.chunks = [];
    // this.stream = null;
    // this.audioContext = new (window.AudioContext ||
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    //   (window as any).webkitAudioContext)();
    // this.mediaStreamDestination = this.audioContext.createMediaStreamDestination();
    this.ondataavailable = null;
    this.onstop = null;

    // void this.init();
  }

  public static getInstance(): OfflineRecorderV2 {
    if (!OfflineRecorderV2.instance) {
      OfflineRecorderV2.instance = new OfflineRecorderV2();
    }
    return OfflineRecorderV2.instance;
  }

  // private async init() {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //     void this.handleStream(stream);
  //   } catch (error) {
  //     logger.error('Error accessing audio devices:', error);
  //   }
  // }

  private handleStream() {
    if (this.mediaRecorder) {
      stopMediaRecorder(this.mediaRecorder);
      this.mediaRecorder = null;
    }

    let stream;
    if (
      posthog.isFeatureEnabled('release-chunk-recording') ||
      posthog.getFeatureFlag('config-default-transcriber') === GEMINI_TRANSCRIBER
    ) {
      stream = store.getState().audio.mediaStreamAudioDestinationNode?.stream;
    } else {
      stream = store.getState().audio.audioStream;
    }

    if (!stream) {
      logger.debug('no stream');
      return;
    }
    this.mediaRecorder = new MediaRecorder(stream, {});

    // const source = this.audioContext.createMediaStreamSource(stream);
    // source.connect(this.mediaStreamDestination);

    //   const mimeType = this.getSupportedMimeType();

    // this.mediaRecorder = new MediaRecorder(stream, {});

    // this.mediaRecorder.addEventListener() = (e: BlobEvent) => {
    //   debugger;
    //   if (this.ondataavailable) {
    //     this.ondataavailable(e.data);
    //   }
    //   this.chunks.push(e.data);
    // };

    // Handling mediaRecorder events
    this.mediaRecorder?.addEventListener('dataavailable', (e) => {
      // logger.debug('audioRecorder data available', e.data.size);

      //   debugger
      if (this.ondataavailable) {
        this.ondataavailable(e.data);
      }
      this.chunks.push(e.data);
    });

    this.mediaRecorder.addEventListener('stop', () => {
      const mimeType = this.mediaRecorder?.mimeType;
      const blob = new Blob(this.chunks, { type: mimeType });
      this.chunks = [];
      if (this.onstop) {
        this.onstop(blob);
      }
      // Handle the blob further if needed (e.g., save, play, upload)
    });
  }

  public start() {
    // if (!this.stream) {
    //   await this.init();
    // }

    this.handleStream();
    // debugger;
    if (this.mediaRecorder && this.mediaRecorder.state === 'inactive') {
      this.mediaRecorder.start(1000);
    }
  }

  public stop() {
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop();
    }
  }

  public setOnDataAvailableHandler(handler: OnDataAvailableHandler) {
    this.ondataavailable = handler;
  }

  public setOnStopHandler(handler: OnStopHandler) {
    this.onstop = handler;
  }

  public changeInputDevice() {
    return;
  }
}

const isBrowser = () => typeof window !== 'undefined'; //The approach recommended by Next.js

export default isBrowser() ? OfflineRecorder.getInstance() : null;
